import styled from "@emotion/styled";

import { fontMerriweather, fontRoboto, theme } from "shared/lib/styles";

import { EntityLink } from "scmp-app/components/entity-link";

export const LiveTagContainer = styled.div`
  &:not(:empty):not(:last-child) {
    margin-block-end: 12px;
  }
`;

export const TopicLinkContainer = styled.div`
  &:not(:empty):not(:last-child) {
    margin-block-end: 4px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;

  margin-block-end: 12px;

  font-weight: 900;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 26px;

  ${theme.breakpoints.up("tablet")} {
    font-size: 20px;
    line-height: 28px;
  }
`;

export const Cover = styled.div`
  inline-size: 70px;
  block-size: 70px;
  margin-block-end: 12px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 150px;
    block-size: auto;
    margin-block-end: 0;
  }
`;

export const Content = styled.div`
  color: #666666;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 22px;

  &:not(:empty) {
    margin-block-end: 12px;
  }

  ${theme.breakpoints.up("tablet")} {
    font-size: 14px;
    line-height: 18px;

    &:not(:empty) {
      margin-block-end: 12px;
    }
  }
`;

export const Footer = styled.div`
  color: #a1a1a1;
  font-size: 12px;
  font-family: ${fontRoboto};
`;

export const StyledHeadlineEntityLink = styled(EntityLink)`
  position: relative;

  inline-size: 100%;

  color: #000000;
`;

export const StyledCoverEntityLink = styled(EntityLink)`
  position: relative;

  inline-size: 100%;
  block-size: 100%;

  color: #000000;

  ${theme.breakpoints.up("tablet")} {
    block-size: auto;
  }
`;

export const Container = styled.div`
  display: grid;
  grid:
    "header . cover" min-content
    "content content content" min-content
    "footer footer footer" min-content
    / 1fr 20px min-content;

  &:hover {
    ${StyledHeadlineEntityLink},${StyledCoverEntityLink} {
      color: #2c4692;
    }
  }

  ${theme.breakpoints.up("tablet")} {
    grid:
      "cover . header" min-content
      "cover . content" min-content
      "cover . footer" min-content
      "cover . ." min-content
      / min-content 20px auto;
  }

  ${Cover} {
    grid-area: cover;
  }

  ${Header} {
    grid-area: header;
  }

  ${Content} {
    grid-area: content;
  }

  ${Footer} {
    grid-area: footer;
  }
`;
